import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Datagrid from '../ui/Datagrid';
import { gridClasses } from '@mui/x-data-grid';
import columns from './table_config';
import { Grid, TablePagination } from '@mui/material';
import { renderCell } from '../ui/Datagrid/table_config';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { downloadHydraulicsLogs, listHydraulicsLogs } from '../../store/actions/hydraulicsLogs';

// eslint-disable-next-line react/prop-types
function CustomPagination({ currentPage, limit, totalCount, handlePagination, loading }) {
  return (
    <TablePagination
      component="div"
      count={totalCount}
      page={currentPage}
      onPageChange={(event, page) => !loading && handlePagination(page)}
      rowsPerPage={limit}
      rowsPerPageOptions={[]}
    />
  );
}

const HydraulicsLog = () => {
  const hydraulicsLogs = useSelector((state) => state.hydraulicsLogs);

  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const [filter, setFilter] = useState([]);
  const [logsDownload, setLogsDownload] = useState(false);

  const renderJsonField = ({ value }) => {
    return <ReactJson src={value} name={false} collapsed={true} sortKeys={true} />;
  };

  const handlePagination = (page) => {
    if (page < hydraulicsLogs.currentPage) {
      dispatch(listHydraulicsLogs({ page: hydraulicsLogs.currentPage - 1 }));
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LOGS_SET_CURRENT_PAGE,
        payload: hydraulicsLogs.currentPage - 1
      });
    } else {
      dispatch(listHydraulicsLogs({ page: hydraulicsLogs.currentPage + 1 }));
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LOGS_SET_CURRENT_PAGE,
        payload: page + 1
      });
    }
    apiRef.current.setFilterModel({
      items: filter
    });
    apiRef.current.scrollToIndexes({
      rowIndex: 0,
      colIndex: 0,
    });
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <Datagrid
          apiRef={apiRef}
          data={hydraulicsLogs.data}
          columns={columns(renderCell, renderJsonField)}
          loading={hydraulicsLogs.loading || logsDownload}
          disableStickyHeader={false}
          height={'90vh'}
          getRowId={(row) => row.grid_id}
          getRowHeight={() => 'auto'}
          autoPageSize={false}
          autoHeight={false}
          pagination={false}
          hideFooter
          experimentalFeatures={{ newEditingApi: true }}
          filterMode="server"
          onFilterModelChange={ (model) => {
            setFilter(model.items);
            const items = model.items.map(filter => {
              if (filter.field === 'caller' || filter.field === 'payload') {
                return { ...filter, field: 'details.' + filter.field };
              } else {
                return filter;
              }
            });
            const filterModels = { ...model, items };
            dispatch({
              type: REDUX_ACTIONS.HYDRAULICS_LOGS_SET_FILTER,
              payload: filterModels.items.length ? filterModels : {}
            });
          }}
          sortingMode="server"
          serverExport={() => {
            setLogsDownload(true);
            dispatch(downloadHydraulicsLogs(() => {
              setLogsDownload(false);
            }));
          }}
          onSortModelChange={(sortModel) => {
            const sort = sortModel.reduce((result, item) => {
              if (item.field === 'payload' || item.field === 'response') {
                result['details.' + item.field] = item.sort;
              } else {
                result[item.field] = item.sort;
              }
              return result;
            }, {});
            dispatch({
              type: REDUX_ACTIONS.HYDRAULICS_LOGS_SET_SORT,
              payload: sort
            });
            dispatch({
              type: REDUX_ACTIONS.HYDRAULICS_LOGS_SET_CURRENT_PAGE,
              payload: 1
            });
            dispatch(listHydraulicsLogs());
          }}
          sx={{
            pointerEvents: logsDownload ? 'none' : 'auto',
            '.MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold !important',
            },
            [`& .${gridClasses.cell}`]: {
              py: 1,
            },
          }}
          toolbar={{
            options: {
              columns: true,
              filters: true,
              density: true,
              export: {
                enabled: true,
                options: true,
                serverExportMode: true
              },
            },
          }}
        />
        <CustomPagination
          currentPage={hydraulicsLogs.currentPage - 1}
          limit={hydraulicsLogs.limit}
          totalCount={hydraulicsLogs.totalCount}
          handlePagination={handlePagination}
          loading={hydraulicsLogs.loading}
        />
      </Grid>
    </Grid>
  );
};

HydraulicsLog.propTypes = {
  row: PropTypes.object,
};

export default HydraulicsLog;
